import React, { Component } from "react";
import PropTypes from "prop-types";
import apiClient from "../../actions/api-client";
import PdfThumbnail from "../pdfViewer/PdfThumbnail";
import { s3Upload } from "../activities/uploader/s3-uploader";

const UPLOAD_ICON = (
  <svg width="80" height="80" viewBox="0 0 80 80">
    <rect
      x="10"
      y="10"
      width="60"
      height="60"
      rx="12"
      fill="#e7f3ff"
      stroke="#44b0ff"
      strokeWidth="3"
    />
    <g>
      <path
        d="M40 55V25"
        stroke="#44b0ff"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <polyline
        points="30,35 40,25 50,35"
        fill="none"
        stroke="#44b0ff"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </g>
    <rect x="25" y="58" width="30" height="7" rx="2" fill="#44b0ff" />
  </svg>
);

class UploadContainer extends Component {
  state = {
    uploading: false,
    error: "",
    uploaded: false,
    fileType: "",
    localPreview: "",
    fileName: "",
    includeInQuestions: false, // ✅ added
  };

  handleClick = () => {
    if (!this.state.uploading) this.fileInput.click();
  };

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const isImage = file.type.startsWith("image/");
    const isPDF = file.type === "application/pdf";

    if (!isImage && !isPDF) {
      this.setState({ error: "Only image or PDF files are allowed." });
      return;
    }

    const localPreview = URL.createObjectURL(file);

    this.setState({
      uploading: true,
      error: "",
      fileType: isImage ? "image" : "pdf",
      localPreview,
      uploaded: false,
      fileName: file.name,
    });

    const params = {};
    const pathTemplate =
      "/getUploadURLForAIGeneration?fileName=" + encodeURIComponent(file.name);
    const method = "GET";
    const additionalParams = {};
    const body = {};
    let localS3Key = "";
    apiClient
      .invokeApi(params, pathTemplate, method, additionalParams, body)
      .then(async (result) => {
        const { uploadUrl, s3Key } = result.data;
        const localS3Key = s3Key; // ✅ define here, scoped to async chain

        const res = await fetch(uploadUrl, {
          method: 'PUT',
          headers: { 'Content-Type': file.type },
          body: file,
        });

        if (!res.ok) throw new Error('Upload failed');

        const uploaded = await s3Upload(file, 'froalaUploads');

        this.setState({ uploading: false, uploaded: true });

        if (this.props.onUpload) {
          this.props.onUpload({
            s3Key: localS3Key,
            url: uploaded.Location,
            fileName: file.name,
            fileType: file.type,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ error: 'Upload failed. Try again.', uploading: false });
      });

  };

  handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    this.setState({ includeInQuestions: checked });
    if (this.props.onIncludeChange) this.props.onIncludeChange(checked);
  };

  render() {
    const {
      uploading,
      uploaded,
      error,
      fileType,
      localPreview,
      fileName,
      includeInQuestions,
    } = this.state;
    const externalError = this.props.error;

    return (
      <div style={{ margin: 16 }}>
        <div
          style={{
            border: "2px dashed #44b0ff",
            borderRadius: 8,
            padding: 20,
            background: "#fafdff",
            cursor: uploading ? "wait" : "pointer",
            textAlign: "center",
            minHeight: 180,
            position: "relative",
            width: "100%",
            height: "calc(100% - 40px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
          onClick={this.handleClick}
        >
          {!uploaded && UPLOAD_ICON}
          {!uploaded && (
            <div style={{ fontWeight: "bold", color: "#222", marginTop: 12 }}>
              Click here to upload image or PDF
            </div>
          )}

          <input
            type="file"
            accept="image/*,application/pdf"
            ref={(ref) => (this.fileInput = ref)}
            style={{ display: "none" }}
            onChange={this.handleFileChange}
            disabled={uploading}
          />

          {uploading && (
            <div
              style={{ color: "blue", position: "absolute", bottom: "18px" }}
            >
              Uploading...
            </div>
          )}

          {(error || externalError) && (
            <div
              style={{
                color: "red",
                position: "absolute",
                bottom: "18px",
                width: "100%",
                textOverflow: "ellipsis",
                overflow: "hidden",
                padding: "0px 10px",
              }}
            >
              {error || externalError}
            </div>
          )}

          {uploaded && (
            <div style={{ marginTop: 12 }}>
              {fileType === "image" && localPreview ? (
                <img
                  src={localPreview}
                  alt="Preview"
                  style={{
                    maxWidth: 160,
                    maxHeight: 120,
                    display: "block",
                    margin: "8px auto",
                  }}
                />
              ) : (
                <PdfThumbnail
                  url={localPreview}
                  name={fileName}
                  scale={0.3}
                  maxWidth={"120px"}
                />
              )}
            </div>
          )}
        </div>

        {/* ✅ Checkbox (your style, minimal addition) */}
        <div
          className="fieldBox"
          key="includeInQuestionsBox"
          style={{ marginTop: 10, display: "none" }}
          onClick={(e) => e.stopPropagation()} // prevent file picker
        >
          <input
            type="checkbox"
            id="includeInQuestions"
            className="css-checkbox"
            name="includeInQuestions"
            checked={includeInQuestions}
            onChange={this.handleCheckboxChange}
          />
          <label htmlFor="includeInQuestions" className="css-label1" style={{ display: "flex", alignItems: "center" }}>
            Make uploads part of questions
          </label>
        </div>
      </div>
    );
  }
}

UploadContainer.propTypes = {
  onUpload: PropTypes.func,
  error: PropTypes.string,
  onIncludeChange: PropTypes.func,
};

export default UploadContainer;
